<template>
  <div class="page">
    <div class="page-content">
      <div v-if="isStandardScreen" class="page-img-container">
        <slot name="left-icon">
          <img class="page-img" src="@assets/svgs/bg-guide-add-device.svg" alt="" />
        </slot>
      </div>
      <div class="page-content-container">
        <span class="cancel-btn" @click="emit('cancel')">{{ $t('owork_base.cancel') }}</span>
        <slot name="right-content">
          <div class="page-content-text">
            <div class="page-content-model">{{ $t('owork_base.pull_device.enable_device') }}</div>
            <div class="page-content-text-describe">{{ $t('owork_base.pull_device.enable_device_tips') }}</div>
          </div>
        </slot>
      </div>
      <div v-if="!needPromptEnableOWork" class="page-bottom-tips">
        <img class="page-img" src="@assets/svgs/icon-connect-privacy-policy.svg" alt="" />

        <span>{{ $t('owork_base.pull_device.pull_device_tips') }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { useSharedScreen } from '@/core/compositions/Screen'

  const { isStandardScreen } = useSharedScreen()

  defineProps<{
    needPromptEnableOWork?: boolean
  }>()

  const emit = defineEmits(['cancel'])
</script>

<style lang="stylus" scoped>
  @import '../styles/devicesModal.styl'
  .page-content-text
    margin-top 169px
    .page-content-text-describe
      line-height 19.88px

  @import '../styles/h5Adaptive/GuidePopperComponent.styl'
</style>
